import * as React from 'react';
import type { OnlineStudySubject } from '../../../ViewModel/Subjects/OnlineStudySubject.csharp';
import { Link } from '~/Partials/Link/Link';
import { moneyToString } from '~/Partials/Utils/utils';
import styles from './Subject.module.css';

export const Subject: React.FC<React.PropsWithChildren<OnlineStudySubject>> = subject => (
    <li key={subject.code} className={styles.Item}>
        <div className={styles.ItemName}>
            <Link label={subject.name} href={subject.url} />
        </div>
        <div className={styles.ItemInfo}>
            <span className={styles.ItemPoints}>
                {subject.credits} {subject.creditsLabel}
            </span>
            <span>{moneyToString(subject.price)}</span>
        </div>
    </li>
);
